import { configureStore } from '@reduxjs/toolkit';
import appReducer from './app.reducer';

const store = configureStore({
  reducer: appReducer,
})

export default store